import script from "./MenuActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./MenuActivity.vue?vue&type=script&lang=ts&setup=true"

import "./MenuActivity.vue?vue&type=style&index=0&id=56b5ccb3&lang=scss"

const __exports__ = script;

export default __exports__